import React             from 'react';
import ActivityIndicator from '../../shared/activity-indicator/activity-indicator.jsx';

class LaunchAs extends React.Component {

    UNSAFE_componentWillMount() {//eslint-disable-line
        this.props.launchAs();
    }

    render() {
        const { busyLaunchAs } = this.props;

        return(
           <div className="launch-as">
                {
                    busyLaunchAs &&
                    <ActivityIndicator visible = { busyLaunchAs }/>
                }
           </div>
        );
    }

}
export default LaunchAs;
